import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

// Compact collection motifs, drawn locally so they do not need remote assets.
function collectionIcon(shape) {
	return function CollectionIcon(props) {
		return (
			<SvgIcon {...props} viewBox="0 0 24 24">
				<g
					fill="none"
					stroke="currentColor"
					strokeWidth="1.6"
					strokeLinecap="round"
					strokeLinejoin="round"
				>
					{shape}
				</g>
			</SvgIcon>
		);
	};
}

const Brick = collectionIcon(
	<>
		<rect x="3" y="9" width="18" height="12" rx="1.5" />
		<path d="M6 9V5h4v4m4 0V5h4v4M3 15h18M9 9v12m6-12v12" />
	</>
);
const Flame = collectionIcon(
	<>
		<path d="M12 2c1 5 5 6 5 10 2-1 2-3 2-3 4 7 0 13-7 13S1 16 5 9c0 3 2 4 2 4-1-5 4-6 5-11Z" />
		<path d="M12 13c0 3-3 4-3 6a3 3 0 0 0 6 0c0-2-2-3-3-6Z" />
	</>
);
const Pokeball = collectionIcon(
	<>
		<circle cx="12" cy="12" r="9" />
		<path d="M3 12h6m6 0h6" />
		<circle cx="12" cy="12" r="3" />
		<circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" />
	</>
);
const Eye = collectionIcon(
	<>
		<path d="M2 12s4-6 10-6 10 6 10 6-4 6-10 6S2 12 2 12Zm10 6v4m-5-5-2 3m12-3 2 3M12 2v4" />
		<circle cx="12" cy="12" r="3" />
	</>
);
const Swords = collectionIcon(
	<>
		<path d="m4 3 5 2 11 14-2 2L5 8 4 3Zm16 0-5 2L4 19l2 2L19 8l1-5ZM3 16l5 5m8-18 5 5M16 21l5-5M3 8l5-5" />
	</>
);
const Wind = collectionIcon(
	<>
		<path d="M3 8h12a3 3 0 1 0-3-3M2 12h17a3 3 0 1 1-3 3M4 17h7a2 2 0 1 1-2 2" />
	</>
);
const Spark = collectionIcon(
	<>
		<path d="m12 2 3 7 7 3-7 3-3 7-3-7-7-3 7-3 3-7Z" />
		<path d="m19 2 1 2 2 1-2 1-1 2-1-2-2-1 2-1 1-2Z" />
	</>
);
const DigitalDevice = collectionIcon(
	<>
		<rect x="4" y="3" width="16" height="18" rx="4" />
		<rect x="7" y="6" width="10" height="8" rx="1" />
		<path d="M8 17v3m-1.5-1.5h3M15 17h.01M17 19h.01M9 9h2v2H9zM13 9h2v2h-2z" />
	</>
);
const Helmet = collectionIcon(
	<>
		<path d="M5 19 3 21h18l-2-2V9a7 7 0 0 0-14 0v10ZM5 11l5 2v2H6m13-4-5 2v2h4m-6-1-3 6h6l-3-6Z" />
		<path d="M8 18v2m8-2v2M12 3v8" />
	</>
);
const Lightsabers = collectionIcon(
	<>
		<path d="m5 3 15 15-2 2L3 5l2-2Zm14 0 2 2L6 20l-2-2L19 3ZM2 19l3 3m14-3 3 3" />
	</>
);
const StrawHat = collectionIcon(
	<>
		<path d="M7 13V9a5 5 0 0 1 10 0v4M7 11h10" />
		<ellipse cx="12" cy="15" rx="10" ry="3" />
		<path d="M8 19h8m-6 0v2m4-2v2" />
	</>
);
const Rune = collectionIcon(
	<>
		<path d="m12 2 8 5v10l-8 5-8-5V7l8-5Zm0 4-4 6 4 6 4-6-4-6Zm0 0v12M8 12h8" />
	</>
);

export const COLLECTION_ICONS = {
	lego: Brick,
	magic: Flame,
	pokemon: Pokeball,
	yugioh: Eye,
	'flesh-and-blood': Swords,
	'force-of-will': Wind,
	lorcana: Spark,
	digimon: DigitalDevice,
	'star-wars-destiny': Helmet,
	'star-wars-unlimited': Lightsabers,
	'one-piece': StrawHat,
	riftbound: Rune
};
